import DOMPurify from 'dompurify'

// Client side twin of Hellobars::MessageSanitizer (Ruby). The stored message is
// already sanitized by the server; this runs again before v-html, and on the
// admin page so the preview and the character count match what will be saved.

const BLOCK_BREAK = /<\/p>\s*<p[^>]*>|<br\s*\/?>/gi

const CONFIG = {
  ALLOWED_TAGS: ['strong', 'em', 'u', 'a'],
  ALLOWED_ATTR: ['href', 'target', 'rel'],
  // https, or a same site path. "//host" is an external link in disguise.
  ALLOWED_URI_REGEXP: /^(?:https:\/\/|\/(?!\/))/i,
  RETURN_TRUSTED_TYPE: false,
}

export function sanitizeHellobarHtml(html) {
  const flattened = String(html || '').replace(BLOCK_BREAK, ' ')
  const clean = DOMPurify.sanitize(flattened, CONFIG)
  const doc = new DOMParser().parseFromString(`<div>${clean}</div>`, 'text/html')
  const root = doc.body.firstChild

  root.querySelectorAll('a').forEach((link) => {
    // DOMPurify drops an unsafe href but keeps the <a>: unwrap it to plain words.
    if (!link.getAttribute('href')) {
      link.replaceWith(...link.childNodes)
      return
    }
    link.setAttribute('target', '_blank')
    link.setAttribute('rel', 'noopener noreferrer')
  })

  return root.innerHTML.replace(/\s+/g, ' ').trim()
}

// What a reader sees, for the length limit and the empty check.
export function hellobarPlainText(html) {
  const doc = new DOMParser().parseFromString(String(html || '').replace(BLOCK_BREAK, ' '), 'text/html')
  return (doc.body.textContent || '').replace(/\s+/g, ' ').trim()
}
